interface ErrorMessageProps {
  message: string
  onRetry?: () => void
  className?: string
}

export function ErrorMessage({
  message,
  onRetry,
  className = '',
}: ErrorMessageProps) {
  return (
    <div className={`text-center py-12 ${className}`}>
      <div className='w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-4'>
        <svg
          className='w-8 h-8 text-red-600 dark:text-red-400'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
          />
        </svg>
      </div>

      <h3 className='text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2'>
        Une erreur est survenue
      </h3>
      <p className='text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto'>
        {message}
      </p>

      {onRetry && (
        <button
          onClick={onRetry}
          className='bg-gradient-to-r bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg font-medium transition-all duration-200 shadow-lg shadow-primary-600/30 hover:shadow-xl hover:shadow-primary-600/40'
        >
          Réessayer
        </button>
      )}
    </div>
  )
}
